import { endOfDay, isAfter as isAfterFns, max as maxFns, parseISO } from "date-fns"

const parse = (input) => {
  if (input == null || input === "") return null
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input
  const parsed = typeof input === "string" ? parseISO(input) : new Date(input)
  return isNaN(parsed.getTime()) ? null : parsed
}

// Note: the input is pushed to 23:59:59 before comparing, so a licence expiring today still counts as active.
export const isAfter = (input, compareWith = new Date()) => {
  const a = parse(input)
  const b = parse(compareWith)
  if (!a || !b) return null
  return isAfterFns(endOfDay(a), b)
}

export const max = (dates) => {
  const parsed = dates.map(parse).filter(Boolean)
  if (!parsed.length) return null
  return maxFns(parsed)
}
